import { render, staticRenderFns } from "./incoming-call-draggable.vue?vue&type=template&id=62917128&scoped=true&"
import script from "./incoming-call-draggable.vue?vue&type=script&lang=js&"
export * from "./incoming-call-draggable.vue?vue&type=script&lang=js&"
import style0 from "./incoming-call-draggable.vue?vue&type=style&index=0&id=62917128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62917128",
  null
  
)

export default component.exports